import { Box, Button, Typography } from "@material-ui/core"

import { AzpEventEntry } from "../../types.results.reignite"
import { profileImageUrl } from "../../utils/profileImageUrl"

import { useAthleteCardStyles } from "./styles"
import { AthletePhoto } from "./AthletePhoto"

type AthleteCardProps = {
  entry: AzpEventEntry | null
  isLoadingEntry: boolean
}

// The "Follow" button is an integral part of the athlete's card, but for the first version of ARP we do not show it
const isFollowButtonVisible = false

const AthleteCard = ({
  entry,
  isLoadingEntry,
}: AthleteCardProps) => {
  const styles = useAthleteCardStyles()

  if (isLoadingEntry) {
    return (
      <Box className={styles.container}>
        <AthletePhoto isLoading imageUrl={null} />

        <Box className={styles.body}>
          <Box className={styles.skeletonDisplayName} />
          <Box className={styles.skeletonDetails} />
        </Box>
      </Box>
    )
  }

  if (!entry) {
    return (
      <Box className={styles.container}>
        <Typography>
          Athlete not found
        </Typography>
      </Box>
    )
  }

  const imageUrl = (entry.racerId && profileImageUrl(entry.racerId)) || null
  const isLocationAvailable = !!(entry.location?.locality && entry.location?.country)

  return (
    <Box className={styles.container}>
      <AthletePhoto
        displayName={entry.displayName}
        imageUrl={imageUrl}
        isMember={!!entry.racerId}
      />

      <Box className={styles.body}>
        <Typography className={styles.displayName}>
          {entry.displayName}
        </Typography>

        <Box className={styles.detailsContainer}>
          <Typography className={styles.details}>
            {entry.gender} {entry.age}
          </Typography>

          {isLocationAvailable && (
            <>
              <Box className={styles.detailsDivider} />

              <Typography className={styles.details}>
                {entry.location.locality}, {entry.location.country}
              </Typography>
            </>
          )}
        </Box>

        {(!!entry.bib || isFollowButtonVisible) && (
          <Box className={styles.bibWrapper}>
            {!!entry.bib && (
              <Box className={styles.bibContainer}>
                <Typography className={styles.bibTitle}>
                  BIB
                </Typography>

                <Box className={styles.bibNumberWrapper}>
                  <Box />

                  <Typography className={styles.bibNumber}>
                    {entry.bib}
                  </Typography>
                </Box>
              </Box>
            )}

            {isFollowButtonVisible && (
              <Button className={styles.followButton}>
                + Follow
              </Button>
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export { AthleteCard }
